import { render } from "./UiPwa.vue?vue&type=template&id=e0909df2"
import script from "./UiPwa.vue?vue&type=script&lang=js"
export * from "./UiPwa.vue?vue&type=script&lang=js"

import "./UiPwa.vue?vue&type=style&index=0&id=e0909df2&lang=sass"

import exportComponent from "/home/runner/work/valeriya-artist/valeriya-artist/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__